import { RouteRecordRaw } from 'vue-router'

const sourceCatalogListingRoute: RouteRecordRaw = {
  name: 'sourceCatalogListing',
  path: 'products',
  component: () => import('./SourceCatalogListing.vue'),
  meta: {
    requireAuth: true,
    title: 'All Products'
  }
}

export default sourceCatalogListingRoute
